import './wdyr'
import 'regenerator-runtime/runtime'
import ReactDOM from 'react-dom'
import React, { FunctionComponent } from 'react'
import { Provider } from 'react-redux'
import { history, store } from './redux/store'
import Main from './components/Main'
import { ConnectedRouter } from 'connected-react-router'
import { HTML5Backend } from 'react-dnd-html5-backend'
import '../sass/index.sass'
import { DndProvider } from 'react-dnd'
import { QueryParamProvider } from 'use-query-params'
import { Route } from 'react-router-dom'
import { userActions } from './redux/global/user/user-actions'
import { flow, pipe } from 'fp-ts/function'
import * as O from 'fp-ts/Option'
import * as IO from 'fp-ts/IO'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import registerServiceWorker from './workers/push.service-worker.ts'
import { fromPromise } from 'rxjs/internal-compatibility'
import { catchError, map, mergeMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { apiRequests } from './http/config'
import { toastFailedResponse } from './components/controls/Toaster/Toaster'
import { getItem } from 'fp-ts-local-storage'
import { urlBase64ToUint8Array } from './utils/utils'

fromPromise(registerServiceWorker()).pipe(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    mergeMap((registration: ServiceWorkerRegistration) => fromPromise(registration.pushManager.getSubscription()).pipe(
        mergeMap((subscription: PushSubscription | null) => subscription ?
            of(subscription) :
            fromPromise(registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(localStorage.getItem('applicationServerKey') ?? '')
            }))
        ),
        mergeMap((pushSubscription: PushSubscription) => apiRequests.notification.push({ data: pushSubscription })),
        map(res => res.response ?
            console.info('successful push subscription') :
            toastFailedResponse(res.response, 'Подписка на пуши не удалась'))
    )),
    catchError(error => of(console.error('push subscription fail', error)))
).subscribe()

const loginProgram = pipe(
    getItem('api-token'),
    IO.map(O.map(flow(userActions.login.success, store.dispatch)))
)

loginProgram()

const Application: FunctionComponent = () => {
    return <Provider store={store}>
        <ConnectedRouter history={history}>
            <DndProvider backend={HTML5Backend}>
                <QueryParamProvider ReactRouterRoute={Route}>
                    <Main/>
                </QueryParamProvider>
            </DndProvider>
        </ConnectedRouter>
    </Provider>
}

window.onload = () => {
    ReactDOM.render(
        <Application/>,
        document.getElementById('app-root'),
    )
}